import React, { ReactElement, ReactNode } from 'react';
import cn from 'classnames';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

type Props = {
    color ?: 'primary' | 'secondary';
    type ?: 'filled' | 'outlined' | 'empty'
    role ?: 'submit' | 'button'
    className ?: string;
    children : ReactNode;
    isLoading ?: boolean;
    [key : string] : any;
};

const Button : React.FC<Props> = ({
    href, type = 'filled', color = 'primary', className = '', children, role = 'button', isLoading = false, ...props
}) : ReactElement => {
    return (
        <button
            role={role}
            className={cn(
                'duration-200 rounded-[40px] text-[1.125rem] leading-[24px] font-semibold active:bg-none',
                {
                    'flex flex-row items-center justify-center': type === 'filled',
                    'bg-[#7041AC] hover:bg-[#471785] text-white py-[14px] px-[20px] border-0': type === 'filled' && color === 'primary',
                    'bg-[#FFFFFF] hover:bg-[#e5e3e8] text-[#14274D] py-[14px] px-[20px] border-0': type === 'filled' && color === 'secondary',
                    'text-[#14274D] px-[20px] h-full hover:text-[#7041AC] bg-transparent border-0': type === 'empty',
                    'bg-transparent border-secondaryHover border-[1px] px-4 py-1 hover:bg-secondaryHover hover:text-white !text-base': type === 'outlined',
                },
                className,
            )}
            {...props}
            disabled={isLoading}
        >
            {children}

            {
                isLoading && <ArrowPathIcon className='h-5 w-5 ml-2 animate-spin' />
            }
        </button>
    );
};

export default Button;
